import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

import uuid from 'react-uuid';
import { ChipListComponent, ChipsDirective, ChipDirective } from '@syncfusion/ej2-react-buttons';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import { LocalizationContext } from '../../App';
import NavLink from 'react-bootstrap/NavLink';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { ReactSession } from 'react-client-session';
import { useNavigate } from 'react-router-dom';
import { RadioButtonComponent } from '@syncfusion/ej2-react-buttons';
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Button from 'react-bootstrap/Button';
import TextField from "@mui/material/TextField";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { inputLabelClasses } from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";
import { useBeforeunload } from 'react-beforeunload';
import { MapContainer, TileLayer, Marker, Popup, Circle, Polygon, MapConsumer, useMapEvents, useMap } from 'react-leaflet';
import Backdrop from '@mui/material/Backdrop';
import AwesomeMarkers from 'leaflet.awesome-markers';
import * as Leaflet from 'leaflet';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { divIcon } from 'leaflet';
import { dividerClasses } from '@mui/material';
import cloneDeep from 'lodash/cloneDeep';
import { useMediaQuery } from 'react-responsive';

const LoupeMappingDraggableMarker = props => {

    const isMobileView = useMediaQuery({
        query: '(max-width: 900px)'
      })


    const mmap = useMap();
    mmap.getContainer().ondragover = (e) => handleDragOver(e);
    mmap.getContainer().ondrop = (e) => handleDrop(e);

    const mev = useMapEvents({
        click: (e) => {  
            
           //if(isMobileView) {

                if( selectedType && selectedType != "mapmode_delete" ) {
                    handleMarkerConstruction(selectedType, e.latlng.lat, e.latlng.lng);
                }

           //}
        },
        
    });
    
    const item = props.currentItem;
    const selectedType = props.selectedType;    
    const markerSelectedCallbackHandler = props.markerSelectedCallbackHandler;

    const [ markers ] = useState( item['selectedValues'] );
    const [ currentMap, setCurrentMap ] = useState(0);

    const [state, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    const [ showSnack, setShowSnack ] = useState(false);
    const [ snackType, setSnackType ] = useState('error');
    const [ snackMsg, setSnackMsg ] = useState('some error');

    
    item['selectedValues'] = markers;

    // construct marker styles from the icon choices
    const markerStyle = Object();
    item.choices.forEach(c => {
        var currentStyle = c['_attributes']['marker-style'];
        var newIcon = Leaflet.AwesomeMarkers.icon({     
            icon: currentStyle.split(':')[0],
            prefix: "fa",
            markerColor: currentStyle.split(':')[1],
            iconColor: "white",
        });
        markerStyle[c['_attributes']['export-label']] = newIcon;

    });
        
    const handleDragOver = (e) => {        
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
    }

    const handleDrop = (e) => {
        e.preventDefault();
        var coordinates = mmap.mouseEventToLatLng(e);
        var payload = JSON.parse(e.dataTransfer.getData('text/plain'));        
        handleMarkerConstruction( payload.exportLabel, coordinates.lat, coordinates.lng );
    }

    const handleMarkerConstruction = ( type, lat, lng ) => { 
        
        // deep-clone activity items to created marker
        var markerItems = cloneDeep( item.markerItems );
        
        
        var idx = markers.push({ type : type, latitude : lat, longitude : lng, markeritems : markerItems }) -1;         
        forceUpdate();

        if(item.hasMarkerItems) {
            markerSelectedCallbackHandler(markers[idx]);
        }

        item.validator.touched();
        if(item.validator.instantRevalidation) {
            item.validator.revalidate();
        }
    }

    


    return(

        <React.Fragment >

           

            { markers.map( (m, idx) => {
                const position = [ m.latitude, m.longitude ];           
                return( 
                        <Marker eventHandlers={{
                            click: (e) => {  

                                // selectedMapMode
                                if(selectedType === null && item.hasMarkerItems) {
                                    markerSelectedCallbackHandler(idx);
                                }

                                if(selectedType == "mapmode_delete") {
                                    markers.splice( idx, 1 );
                                    forceUpdate();
                                }                    
                            },
                        }} position={position} key={idx} icon={markerStyle[m.type]}/>
                );
            })}

            <Backdrop open={showSnack} sx={{ color: '#000'}}/>
            <Snackbar open={showSnack} autoHideDuration={6000} anchorOrigin={{horizontal:'right',vertical:'top'}} onClick={() => setShowSnack(false)}>
                <Alert severity={snackType} className="padleft point text-start" sx={{ width: '100%' }}>
                    {snackMsg}
                </Alert>
            </Snackbar>




        </React.Fragment>

        
    );

}
export default LoupeMappingDraggableMarker;